import { render, staticRenderFns } from "./QilinAvatar.vue?vue&type=template&id=22f406f0&scoped=true&"
import script from "./QilinAvatar.vue?vue&type=script&lang=js&"
export * from "./QilinAvatar.vue?vue&type=script&lang=js&"
import style0 from "./QilinAvatar.vue?vue&type=style&index=0&id=22f406f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f406f0",
  null
  
)

export default component.exports